import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  SidebarModule,
  NavbarModule,
  ScrollbarModule,
  LogoModule,
  AlertModule,
  FooterModule,
  MainContentModule,
  HeaderModule
} from '@michelin/theme';
import { LayoutComponent } from './layout.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SidebarModule,
    AlertModule,
    NavbarModule,
    LogoModule,
    ScrollbarModule,
    FooterModule,
    MainContentModule,
    HeaderModule,
    LayoutComponent
  ],
  providers: []
})
export class LayoutModule {}
